export const TOMORROW = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
export const END_OF_YEAR = new Date(
  new Date().getFullYear(),
  11,
  31,
  23,
  59,
  59,
  999
);
export const END_OF_NEXT_YEAR = new Date(
  new Date().getFullYear() + 1,
  11,
  31,
  23,
  59,
  59,
  999
);
export const December = new Date(new Date().getFullYear(), 11, 1).getTime();
export const today = new Date().getTime();

export const isTomorrow = (date?: string | null) => {
  if (!date) return false;
  const day = new Date(date).getTime();
  const tomorrow = TOMORROW;

  if (today > December) {
    return (
      day >= tomorrow.setHours(0, 0, 0, 0) && day < END_OF_NEXT_YEAR.getTime()
    );
  }
  return day >= tomorrow.setHours(0, 0, 0, 0) && day < END_OF_YEAR.getTime();
};
